import { getParam } from "utils/paramsValidation";

export const isSearchAutocomplete = (chrome) => {
	const searchEngineParam =
		getParam("searchEngine") || window?.localStorage.getItem("searchEngine");
	const search = searchEngineParam || chrome?.searchEngine;

	return search === "autocomplete";
};
